import store from '../store';
import router from '../router';
var server = axios.create({
  baseURL: api, // node环境的不同，对应不同的baseURL
  timeout: 100000, // 请求的超时时间
})
let Message = ELEMENT.Message;
server.interceptors.response.use((response) => {
  //判断一下响应中是否有 token，如果有就直接使用此 token 替换掉本地的 token。你可以根据你的业务需求自己编写更新 token 的逻辑
  var token = response.headers.authorization
  if (token) {
    // 如果 header 中存在 token，那么触发 refreshToken 方法，替换本地的 token
    store.commit('changeToken', token);
  }
  return response
}, (error) => {
  console.log(error);
  switch (error.response.status) {
    case 422:
      error = error.response.data.errors;
      var keys = Object.keys(error);
      Message.error(error[keys[0]][0]);
      break;
    case 403:
      Message.error(error.response.data.message);
      break;
    case 401:
      if (window.location.href.indexOf('login') > -1) {
        Message.error(error.response.data.message);
      } else {
        //去登录页面
        router.push('/login');
      }
      break;
    case 500:
      Message.error('错误' + error.response.status + '，请联系管理员');
      break;
    default:
      if (error.response && error.response.data && error.response.data.message) {
        Message.error(error.data.message);
      } else {
        Message.error('错误' + error.status + '，请联系管理员');
      }
      break;
  }
  return Promise.reject(error)
})

function post(apis, params, success, err) {
  server.post(apis, params, {
    headers: {
      'Accept': accept,
      'Authorization': store.state.token
    }
  }).then(function(res) {
    success(res)
  }).catch(function(error) {
    err(error)
  })
}

function get(apis, params, success, err) {
  server.get(apis, {
    params: params,
    headers: {
      'Accept': accept,
      'Authorization': store.state.token
    }
  }).then((res) => {
    success(res);
  }).catch((error) => {
    err(error);
  })
}

function form(apis, params, success, err) {
  server.post(apis, params, {
    headers: {
      'Accept': accept,
      'Authorization': store.state.token,
      'content-type': 'application/x-www-form-urlencoded'
    }
  }).then(function(res) {
    success(res)
  }).catch(function(error) {
    err(error)
  })
}

function patch(apis, params, success, err) {
  server.patch(apis, params, {
    headers: {
      'Accept': accept,
      'Authorization': store.state.token
    }
  }).then(function(res) {
    success(res)
  }).catch(function(error) {
    err(error)
  })
}

function put(apis, params, success, err) {
  server.put(apis, params, {
    headers: {
      'Accept': accept,
      'Authorization': store.state.token
    }
  }).then(function(res) {
    success(res)
  }).catch(function(error) {
    err(error)
  })
}

function del(apis, success, err) {
  server.delete(apis, {
    headers: {
      'Accept': accept,
      'Authorization': store.state.token
    }
  }).then(function(res) {
    success(res)
  }).catch(function(error) {
    err(error)
  })
}

export default {
  get: get,
  post: post,
  patch: patch,
  del: del,
  put: put,
  form: form
}



// WEBPACK FOOTER //
// ./src/assets/request.js